/* Colourway swatches on grouped WHF product cards.
   Every colourway's card is already in the DOM (whf-product-card.liquid);
   picking a swatch only switches which card is un-hidden, so images
   lazy-load on first reveal and nothing is fetched up front. */
(function () {
  /* Run once per page: a second grid section emits this script again and
     the swatch handler would fire twice per click. See whf-quick-add.js. */
  if (window.__whfCardSwatchesBound) return;
  window.__whfCardSwatchesBound = true;
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-cg-swatch]');
    if (!btn) return;
    var grp = btn.closest('[data-whf-card-group]');
    if (!grp) return;
    var idx = btn.getAttribute('data-cg-idx');
    grp.querySelectorAll('[data-cg-card]').forEach(function (card) {
      card.hidden = card.getAttribute('data-cg-idx') !== idx;
    });
    grp.querySelectorAll('[data-cg-swatch]').forEach(function (b) {
      var on = b === btn;
      b.setAttribute('aria-pressed', on ? 'true' : 'false');
      b.classList.toggle('is-active', on);
    });
  });
})();
